import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const PermissionDeniedModal = ({ visible, onClose, message = "You are not authorized to perform this action. Please contact your administrator if you believe this is a mistake." }) => {
  return (
    <Modal
      title={
        <div className="flex items-center text-red-600">
          <ExclamationCircleOutlined className="mr-2 text-xl" />
          Permission Denied
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      className="permission-denied-modal"
    >
      <div className="py-4">
        <p className="text-gray-700 text-base">
          {message}
        </p>
      </div>
    </Modal>
  );
};

export default PermissionDeniedModal;
